export default {
  setSuccessMessage({ commit }, { message, title }) {
    commit('SET_SUCCESS_MESSAGE', { message, title })
  },

  setErrorMessage({ commit }, { message, title }) {
    commit('SET_ERROR_MESSAGE', { message, title })
  },

  setInfoMessage({ commit }, { message, title }) {
    commit('SET_ERROR_MESSAGE', { message, title })
  },

  resetStore({ commit }) {
    commit('RESET_STORE')
  },
}
